const EccoSearchCode = {
  version: 'variant-code-v2',

  getVariantCode(value) {
    const compactValue = String(value || '')
      .trim()
      .replace(/[\s-]/g, '');

    return /^\d{11}$/.test(compactValue) ? compactValue : '';
  },

  buildQuery(value) {
    const variantCode = this.getVariantCode(value);
    if (!variantCode) return String(value || '').trim();

    return `${variantCode} OR ${variantCode.slice(0, 6)}`;
  },

  getDisplayTerm(value) {
    const match = String(value || '')
      .trim()
      .match(/^(\d{11})\s+OR\s+\d{6}$/i);

    return match ? match[1] : String(value || '');
  },
};

window.EccoSearchCode = EccoSearchCode;

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.value = EccoSearchCode.getDisplayTerm(this.input.value);
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

document.addEventListener('submit', (event) => {
  if (event.defaultPrevented) return;

  const form = event.target.closest('form[role="search"]');
  const searchInput = form?.querySelector('input[type="search"][name="q"]');
  if (!searchInput) return;

  searchInput.value = EccoSearchCode.buildQuery(searchInput.value);
});

document.querySelectorAll('input[type="search"][name="q"]').forEach((searchInput) => {
  searchInput.value = EccoSearchCode.getDisplayTerm(searchInput.value);
});
